export { Avatar, type IAvatarProps } from './avatar';
